import Typography from 'typography'

const typography = new Typography({
  baseFontSize: "16px",
  baseLineHeight: 1.5,
  scaleRatio: 2.5, //6.854
  headerWeight:'700',
  bodyWeight:'400',
  boldWeight:'700',
  includeNormalize:true,
  //get google fonts
  googleFonts:[
  {
    name: 'Roboto Condensed',
    styles: [
      '700',
    ],
  },
  {
    name: 'Space Mono',
    styles: [
      '400',
      '700',
    ],
  },
],
//set families
  headerFontFamily: [
    "Roboto Condensed",
    "sans-serif",
  ],
  bodyFontFamily: [
    "Space Mono",
    "Roboto Mono",
    "mono",
  ],


//closing braces
})

module.exports = typography



// WEBPACK FOOTER //
// ./src/utils/typography.js